import { Styles } from 'react-jss'

export const sheet: Styles = {
  card: {
    display: 'flex',
    alignItems: 'flex-start',
    background: '#FFFFFF',
    borderRadius: 12,
    padding: '20px 26px 20px 20px',
    boxShadow: '0 1px 2px rgba(16,24,40,0.06), 0 8px 24px rgba(16,24,40,0.08)',
    border: '1px solid rgba(16,24,40,0.06)',
    gap: '16px'
  },

  badge: {
    flex: '0 0 56px',
    height: 56,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    '& svg': {
      width: 24,
      height: 24,
      color: 'currentColor',
      fill: 'currentColor',
      stroke: 'currentColor'
    }
  },

  content: {
    flex: 1
  },

  title: {
    margin: 0,
    fontWeight: 600,
    fontSize: 18,
    lineHeight: 1.3,
    letterSpacing: '0.02em',
    color: '#080910'
  },

  text: {
    margin: '6px 0 0',
    fontSize: 16,
    fontWeight: 300,
    lineHeight: 1.6,
    letterSpacing: '0.03em',
    color: '#000000'
  },

  // тона
  toneBlue: { background: '#EAF2FF', color: '#1B64F2' },
  toneGreen: { background: '#EAF9EF', color: '#29A55C' },
  tonePurple: { background: '#F0EBFF', color: '#6E59F5' },
  toneRed: { background: '#FFEAEA', color: '#F04438' },
  toneOrange: { background: '#FFEDD4', color: '#F54900' }
}
